/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountUnpaidSituationQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountUnpaidSituationQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly unpaidPhase: GraphQL.AccountUnpaidPhase | null, readonly unpaidSince: CK.Timestamp | null, readonly unpaidSituation: GraphQL.AccountUnpaidSituation | null } | null };


export const AccountUnpaidSituationDocument = gql`
    query AccountUnpaidSituation($accountId: AccountId!) {
  account(id: $accountId) {
    id
    unpaidPhase
    unpaidSince
    unpaidSituation
  }
}
    `;

/**
 * __useAccountUnpaidSituationQuery__
 *
 * To run a query within a React component, call `useAccountUnpaidSituationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountUnpaidSituationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountUnpaidSituationQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountUnpaidSituationQuery(baseOptions: Apollo.QueryHookOptions<AccountUnpaidSituationQuery, AccountUnpaidSituationQueryVariables> & ({ variables: AccountUnpaidSituationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountUnpaidSituationQuery, AccountUnpaidSituationQueryVariables>(AccountUnpaidSituationDocument, options);
      }
export function useAccountUnpaidSituationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountUnpaidSituationQuery, AccountUnpaidSituationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountUnpaidSituationQuery, AccountUnpaidSituationQueryVariables>(AccountUnpaidSituationDocument, options);
        }
export function useAccountUnpaidSituationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountUnpaidSituationQuery, AccountUnpaidSituationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountUnpaidSituationQuery, AccountUnpaidSituationQueryVariables>(AccountUnpaidSituationDocument, options);
        }
export type AccountUnpaidSituationQueryHookResult = ReturnType<typeof useAccountUnpaidSituationQuery>;
export type AccountUnpaidSituationLazyQueryHookResult = ReturnType<typeof useAccountUnpaidSituationLazyQuery>;
export type AccountUnpaidSituationSuspenseQueryHookResult = ReturnType<typeof useAccountUnpaidSituationSuspenseQuery>;
export type AccountUnpaidSituationQueryResult = Apollo.QueryResult<AccountUnpaidSituationQuery, AccountUnpaidSituationQueryVariables>;